import { render, staticRenderFns } from "./SeniorDetail.vue?vue&type=template&id=78f66b5b&scoped=true"
import script from "./SeniorDetail.vue?vue&type=script&lang=js"
export * from "./SeniorDetail.vue?vue&type=script&lang=js"
import style0 from "./SeniorDetail.vue?vue&type=style&index=0&id=78f66b5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f66b5b",
  null
  
)

export default component.exports